import { maApiFetch } from './maApi'
import { notifyError } from '../utils/helpers'

export const uploadFiles = (files, maApiHost, authenticatedFetch) => {
  const promises = []
  files.forEach(file => {
    const formData = new FormData()
    formData.append('case[attachment]', file)
    const formBody = {
      method: 'POST',
      enctype: 'multipart/form-data',
      body: formData,
    }
    promises.push(maApiFetch('/eod/attachments', formBody, maApiHost, authenticatedFetch))
  })

  return Promise.all(promises)
    .then(response => {
      if (response.errors) {
        notifyError('Error Uploading File', 'Unable to upload your file. Please try again.')
      } else {
        return response
      }
    })
    .catch(error => {
      notifyError('Error Uploading file', 'Unable to upload your file. Please try again.')
      throw new Error(error)
    })
}
